import EventEmitter from 'events';

const tokenExpiryKey = 'tokenExpiry';
const tokenKey = 'accessToken';
const userInfoKey = 'userInfo';

class AuthService extends EventEmitter {
  init(store) {
    console.log('AuthService:init');
    const storedToken = localStorage.getItem(tokenKey);
    const storedUserinfo = localStorage.getItem(userInfoKey);

    let storedTokenExpiry = false;

    if (localStorage.getItem(tokenExpiryKey)) {
      storedTokenExpiry = JSON.parse(localStorage.getItem(tokenExpiryKey));
    }

    if (storedToken && !store.state.auth.accessToken) {
      store.commit('auth/SET_TOKEN_FROM_LOCALSTORAGE', {
        jwt: storedToken,
        expire: storedTokenExpiry
      });
    }

    if (storedUserinfo) {
      store.commit('auth/UPDATE_USER_INFO', JSON.parse(storedUserinfo));
      if (storedToken) {
        // Refresh user info if possible
        store
          .dispatch('auth/attempt', storedToken)
          .then(response => {
            store.commit('auth/UPDATE_USER_INFO', response.data.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    }

    store.commit('auth/AUTH_INITIALIZED');

    return this.isAuthenticated(store);
  }
  userInfoKey() {
    return userInfoKey;
  }
  tokenExpiryKey() {
    return tokenExpiryKey;
  }
  tokenKey() {
    return tokenKey;
  }
  isUserLoggedIn() {
    return false;
  }

  isAuthenticated(store) {
    console.log(store.state);
    if (!store.state.auth.isInitialized) {
      return this.init(store);
    } else {
      if (store.state.auth.accessToken) {
        return true;
      } else {
        return false;
      }
    }
  }
}

export default new AuthService();
